<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.modelId" :getMethod="getModelById"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]" :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewMachineModelContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.MachineModel
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.machineModelId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.MachineModelChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>